(function() {
    'use strict';

    angular
        .module('searchApp')
        .controller('SearchController', SearchController);

    SearchController.$inject = ['$scope', '$filter', '$window', 'NgTableParams', '$base64', 
                                'GLOBAL_URL', 'FORMAT_DATE', 'TRANSACTION_TYPE', 'TransactionService', 
                                'ReportService','CONST_REPORT','CommonService', 'FileNetService', 'WF_TASK', 
                                'SearchAdditionalService','authExpiredInterceptor','$state','$uibModal'];

    function SearchController($scope, $filter, $window ,NgTableParams, $base64, 
    		GLOBAL_URL, FORMAT_DATE, TRANSACTION_TYPE, TransactionService, 
    		ReportService, CONST_REPORT, CommonService, FileNetService, WF_TASK, 
    		SearchAdditionalService, authExpiredInterceptor, $state, $uibModal) {
    	var searchCtr = this;
    	$scope.CONST_REPORT = CONST_REPORT;
    	$scope.WF_TASK = WF_TASK;
    	searchCtr.showAdvanceFilter = false;
    	searchCtr.fromCreatedDate = new Date();
    	searchCtr.toCreatedDate = new Date();
    	searchCtr.officeCode = null;
    	searchCtr.txnId = null;
    	searchCtr.transactionType = null;
    	searchCtr.receiptNum = null;
    	searchCtr.transactionTypes = [];
    	searchCtr.popupDate = {'fromCreatedDate': false, 'tocreatedDate': false};
    	
    	searchCtr.clickPopupDate = clickPopupDate;
    	searchCtr.toggleAdvanceFilter = toggleAdvanceFilter;
    	searchCtr.getTransaction = getTransaction;
    	searchCtr.getTransactionType = getTransactionType;
    	searchCtr.openTransactionInfo = openTransactionInfo;
    	searchCtr.openPolicyInfo = openPolicyInfo;
    	searchCtr.init = init;
    	searchCtr.printReport = printReport;
    	searchCtr.printTaxInvoice = printTaxInvoice;
    	searchCtr.showLinkDownTaxInvoice = showLinkDownTaxInvoice;
    	searchCtr.setDefaultPrintStatus = setDefaultPrintStatus;

		var currentDate = new Date();
		currentDate.setHours(0,0,0,0)
		var tDate = new Date("04/23/2024")
		if(tDate <= currentDate
			&& document.getElementById("fileTemplateHotlink") != null
			&& document.getElementById("fileTemplateHotlink") != undefined)
		{
			document.getElementById("fileTemplateHotlink").style.display = "none";
		}

    	searchCtr.transactionURLs = CommonService.query({masterurl:'get-transaction-url'});
    	searchCtr.getTransactionURL = function (code) {
    		return _.result(_.find(searchCtr.transactionURLs, function(obj) {
    		    return obj.code === code;
    		}), 'name');
    	}
    	function init() {
    		searchCtr.transactionTypes = CommonService.query({masterurl:'get-all-transaction-type'});
    		/*angular.forEach(TRANSACTION_TYPE, function(value, key) {
    			if (value.enable === true) {
    				searchCtr.transactionTypes.push(value);
    			}
    		});*/
    		searchCtr.reportParam = {'fromDate': searchCtr.fromCreatedDate,
					 'toDate': searchCtr.toCreatedDate,
					 'officeCode': searchCtr.officeCode,
					 'policyNum' : null,
					 'receiptNum' : searchCtr.receiptNum,
					 'transactionType': searchCtr.transactionType,
					 'txn_id': searchCtr.txnId,
					 'status': searchCtr.printStatus};
    		searchCtr.reportParam.formatExport = CONST_REPORT.FORMAT_EXPORT[0].code;
    	}
    	
    	function setDefaultPrintStatus(txnType, transactionTypeReceipt) {
    		if(transactionTypeReceipt === 'TG'){
    			if(txnType === '100')
        			searchCtr.printStatus = '1000'; // chon tat ca
        		if(txnType === '200')
        			searchCtr.printStatus = '2000'; // chon tat ca
    		} else if(transactionTypeReceipt === 'DT'){
    			if(txnType === '100')
        			searchCtr.printStatus = '3000'; // chon tat ca
        		if(txnType === '200')
        			searchCtr.printStatus = '4000'; // chon tat ca
    		} else{
    			searchCtr.printStatus = null;
    		}
    		
    	}
    	
    	function clickPopupDate(name) {
    		searchCtr.popupDate[name] = !searchCtr.popupDate[name];
    	}
    	
    	function toggleAdvanceFilter() {
    		searchCtr.showAdvanceFilter = !searchCtr.showAdvanceFilter;
    	}
    	
    	function getTransaction() {
    		TransactionService.get({uri:'check-complain-report-warning-by-txnid', txnId : searchCtr.txnId}, function(result) {
				var detailMessage = '';
				if (result.flagError == '1' || result.flagError == '2') {
					if (result.flagError == '1') {
						detailMessage = 'Nhân viên GA tạm ngưng giao dịch này và liên hệ ngay với CSS phụ trách để được hỗ trợ';
					} else {
						detailMessage = 'Nhân viên GA gởi thông tin cho CSS phụ trách NGAY sau khi hoàn tất giao dịch';
					}
					
					var modalInstance = $uibModal.open({
						animation : true,
						templateUrl : GLOBAL_URL
						+ 'partial?uri=ga/search/comp-report-warning-dialog',
						controller : 'CompReportWarningDialogController',
						controllerAs : 'vm',
						size : 'lg',
						resolve : {
							detailMessage : function() {
								return detailMessage;
							}
						}
					});
					
					modalInstance.result.then(function(result) {
						if(result =='1'){
							searchCtr.tableParams.page(1);
				    		searchCtr.tableParams.reload();
						} else {
							$state.transitionTo($state.current, {}, { 
					   			  reload: true, inherit: false, notify: true
					   		});
						}
					});
				} else {
					searchCtr.tableParams.page(1);
		    		searchCtr.tableParams.reload();
				}
			},function(error) {
				$scope.loading= false;
			});
    	}
    	
    	function getTransactionType(code) {
    		return _.result(_.find(searchCtr.transactionTypes, function(obj) {
    		    return obj.code === code;
    		}), 'name');
    	}

    	function openTransactionInfo(transaction) {
			var uri = null;
			var num = null;
			if (transaction.txnType === '100') {
				uri = 'ga/receipt/#/';
				num = $base64.encode(transaction.txnId);
				if (transaction.customerType === 'P') {
					uri = uri.concat('individual/');
				} else if (transaction.customerType === 'C') {
					uri = uri.concat('corporation/');
				}
			} else if (transaction.txnType === '200') {
				uri = 'ga/receipt/#/policy/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '300') {
				//if (transaction.wfStatus == 'NB_ERROR') {
				var param = {};
				param['uri'] = 'reload';
				param['id'] = transaction.txnId;
				TransactionService.query(param);
				//}
				uri = 'ga/request/#/fileTemplate/';
				var txnIdAf = $base64.encode(transaction.txnId);
				num = $base64.encode(transaction.proposalNum).concat('/').concat(txnIdAf);
				if (transaction.productCode === 'RO1'
					|| transaction.productCode === 'IP1'
					|| transaction.productCode === 'VL4') {
					var productCode = $base64.encode(transaction.productCode);
					uri = 'ga/request/af/#/fileTemplate/';
					uri = uri.concat(productCode).concat('/');
				}
			} else if (transaction.txnType === '400') {

			} else if (transaction.txnType === '500') {
				uri = 'ga/payments/#/authorize/info/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '600') {
				uri = 'ga/claims/#/claim-registration-history/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '610') {
				uri = 'ga/claims/#/claim-adjust-info-history/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '700') {
				uri = 'ga/opinion/#/opinion/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '800') {
				uri = 'ga/adjustaddress/#/adjustaddress/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '900') {
				uri = 'ga/adjustben/#/adjustben/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '1000') {
				uri = 'ga/adjustrecurringfee/#/adjustrecurringfee/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '1100') {
				uri = 'ga/adjustperdetail/#/adjustperdetail/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '1200') {
				uri = 'ga/personalrelation/#/personalrelation/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '1300') {
				uri = 'ga/savecancelcontract/#/savecancelcontract/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '1400') {
				uri = 'ga/othertrans/#/othertrans/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '1500') {
				uri = 'ga/return-letter/#/return-letter-view-detail/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '1600') {
				uri = 'ga/accountpruonline/#/accountpruonline/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '1700') {
				uri = 'ga/receipt/#/policy-reversal/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '1900') {
				uri = 'ga/reg-signature/#/reg-signature/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '1800') {
				uri = 'ga/cfi/#/cancel-cfi/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '2000') {
				uri = 'ga/contract-revert/#/contract-revert/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '2100') {
				uri = 'ga/billing-change/#/billing-change/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '2200') {
				uri = 'ga/request-advance/#/request-advance/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '2300') {
				uri = 'ga/advance-payment/#/advance-payment/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '2400') {
				uri = 'ga/pay-off/#/pay-off/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '2500') {
				uri = 'ga/submit-refund/#/submit-refund/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '2800') {
				uri = 'ga/go-abroad/#/go-abroad/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '2600') {
				uri = 'ga/fund-swap/#/fund-swap/';
				num = $base64.encode(transaction.txnId);
			} else if (transaction.txnType === '2700') {
				uri = 'ga/investment-plus/#/investment-plus/';
				num = $base64.encode(transaction.txnId);
			}

    		uri = uri.concat(num);
    		/*if (transaction.txnType === '500') {
    			var url = searchCtr.getTransactionURL('TRANSACTION_PAYMENT');
    			url = url.concat('/');
    			$window.open(url + uri, '_blank');
    		} else if(transaction.txnType === '2100' || transaction.txnType === '2300') {
    			var url = searchCtr.getTransactionURL('TRANSACTION_BILLING_CHANGE');
    			url = url.concat('/');
    			$window.open(url + uri, '_blank')
			}
    		else {
    			$window.open(GLOBAL_URL + uri, '_blank');
    		}*/
			if (transaction.txnType === '2100') {
				var url = searchCtr.getTransactionURL('TRANSACTION_BILLING_CHANGE');
				url = url.concat('/');
				$window.open(url + uri, '_blank')
			} else if (transaction.txnType === '2800') {
				var url = searchCtr.getTransactionURL('TRANSACTION_GO_ABROAD');
				url = url.concat('/');
				$window.open(url + uri, '_blank')
			} else if(transaction.txnType === '2600') {
				var url = searchCtr.getTransactionURL('TRANSACTION_FUND_SWAP');
				url = url.concat('/');
				$window.open(url + uri, '_blank')
			} else if(transaction.txnType === '2700') {
				var url = searchCtr.getTransactionURL('GA_INVESTMENT_PLUS');
				url = url.concat('/');
				$window.open(url + uri, '_blank')
			} else if (transaction.txnType === '2200'
					|| transaction.txnType === '2300'
					|| transaction.txnType === '2400'
					|| transaction.txnType === '2500') {
				var url = searchCtr.getTransactionURL('TRANSACTION_PRUCASH');
    			url = url.concat('/');
    			$window.open(url + uri, '_blank')
			} else {
				$window.open(GLOBAL_URL + uri, '_blank');
			}
    	}
    	
    	function openPolicyInfo(transaction) {
    		var uri = null;
    		var number = null;
    		if (transaction.policyNum) {
    			uri = 'ga/history/#/constractInfo/';
    			number = $base64.encode(transaction.policyNum);
    		}
    		uri = uri.concat(number);
    		$window.open(GLOBAL_URL + uri, '_blank')
    	}
    	
    	function printTaxInvoice(trans,t) {
    		$scope.loading = true;
    		if(trans.txnType == '100' || trans.txnType == '200') {
	    		FileNetService.get({method:'isExitsInFileNet', receiptNum:trans.receiptNum}, function(result, headers){
	    			$scope.loading = false;
	    			if(headers('X-PRUGAGreatApp-error') !== 'filenet.not.found'){
	    				var uri = null;
	    	    		var number = null;
	    	    		if (trans.policyNum) {
	    	    			uri = 'api/file-net/download?receiptNum=';
	    	    			number = trans.receiptNum;
	    	    		}
	    	    		uri = uri.concat(number) + '?access_token=' + authExpiredInterceptor.getToken();
	    	    		$window.open(GLOBAL_URL + uri, '_blank')
	    			}
	    		})
    		}
    		else if(trans.txnType == '800') {
    			$scope.loading = false;
    			SearchAdditionalService.get({uri : 'getPoliciByTxnId',txnId : trans.txnId}, 
						function(result) {
							if(result != null){
								if(result.addressType==0 || result.addressType==2){
					    			var addressReport = {txnId: trans.txnId, policyNum: trans.policyNum, addressType:result.addressType };
					    			SearchAdditionalService.download({uri:'print-address'}, addressReport,
					    			function(result){
					    				if(result!=null){
					    					if(trans.printStatus==0){
					    						$("#test"+t).text("Hoàn tất");
					    					}
					    				}
					    			});
								}
							}
				});
    		}else if(trans.txnType == '900'){
    			$scope.loading = false;
    			var benReport = {txnId: trans.txnId, policyNum: trans.policyNum};
    			SearchAdditionalService.download({uri:'print-ben'}, benReport,
					  function(result){
					    	if(result!=null){
					    		if(trans.printStatus==0){
					    			$("#test"+t).text("Hoàn tất");
					    		}
					    	}
					  });
    		}else if(trans.txnType == '1000'){
    			$scope.loading = false;
    			var frequencyReport = {txnId: trans.txnId, policyNum: trans.policyNum};
    			SearchAdditionalService.download({uri:'print-frequency'}, frequencyReport,
					    			function(result){
					    				if(result!=null){
					    					if(trans.printStatus==0){
					    						$("#test"+t).text("Hoàn tất");
					    					}
					    				}
					    			});
    		}else if(trans.txnType == '1100'){
    			$scope.loading = false;
    			var txnId=trans.txnId;
    			SearchAdditionalService.post({uri:'doCheckData'},txnId, function(result) {
    				        if(result.flagError==0){
    							 var clientReport = {txnId: trans.txnId, policyNum: trans.policyNum};
    				    		SearchAdditionalService.download({uri:'print-client'}, clientReport,function(result){
					    				if(result!=null){
					    					if(trans.printStatus==0){
					    						$("#test"+t).text("Hoàn tất");
					    					}
					    				}
    				    			SearchAdditionalService.query({uri:'getAdjustPoClientLst',txnId:trans.txnId}, function(data){
	    				    			if(data.length>0){
	    				        			for(var i=0;i<data.length;i++){
	    				        				var item=data[i];
	    				        				if(item.unifield){
	    				        					var paramReport={txnId:trans.txnId,adjustPoId:item.adjustPoClientId,policyNum:trans.policyNum}
	    				        					SearchAdditionalService.download({uri:'print-policy'},paramReport);
	    				        				}
	    				        				if(item.confirm){
						        					var paramReport={txnId:trans.txnId,policyNum:item.policyNum}
						        					SearchAdditionalService.download({uri:'print-policy-con'},paramReport);
						        				}
	    				        			}
	        						    }
    				    			});
    				    			}); 
    				    		}
    					}, function(error){
    	    			});
			} else if(trans.txnType == '2000' || trans.txnType == '2100' || trans.txnType =='2800'){
				$scope.loading = false;
				var paramObj = {'txn_id':trans.txnId, 'transactionType':trans.txnType};
				SearchAdditionalService.download({uri:'print-letter-cfm'}, paramObj,
		    			function(result){
		    				if(result!=null){
		    					if(trans.printStatus==0){
		    						$("#test"+t).text("Hoàn tất");
		    					}
		    				}
		    			}, function (error) {
						self.addAlert("Hệ thống hiện chưa gửi thư lên FILENET. Vui lòng thử lại sau.", "danger");
					});
			} else {
				$scope.loading = false;
			}
    	}
    	
    	function showLinkDownTaxInvoice(transaction) {
    		var desc = transaction.noneWfDesc == null ? (transaction.txnEnable == '0' ? 'Hủy' : transaction.currentTaskName) : transaction.noneWfDesc;
    		var flag = false;
    		if(transaction.txnType == '100' || transaction.txnType == '200') {
    			if(transaction.txnEnable != '0' && transaction.receiptNum != null) {
    				// Show link taxinovoice no
    				transaction.finalStatus='Hoàn tất';
    				flag = true;
    			}
    		}else if(transaction.txnType == '800') {
    			if(transaction.wfStatus=='ADJUST_ADDRESS_END'&&transaction.txnEnable=='1'){
    				if(transaction.printStatus==0){
    					transaction.finalStatus='In thư';
					}else{
						transaction.finalStatus='Hoàn tất';
					}
					flag = true;
				}
    		}else if(transaction.txnType == '900'){
    			if(transaction.wfStatus=='ADJUST_BEN_END'&&transaction.txnEnable=='1'){
    				if(transaction.printStatus==0){
    					transaction.finalStatus='In thư';
					}else{
						transaction.finalStatus='Hoàn tất';
					}
    				flag = true;
				}
    		}else if(transaction.txnType == '1000'){
    			if(transaction.wfStatus=='ADJUST_FREQUENCY_END'&&transaction.txnEnable=='1'){
    				if(transaction.printStatus==0){
    					transaction.finalStatus='In thư';
					}else{
						transaction.finalStatus='Hoàn tất';
					}
    				flag = true;
				}
    		}else if(transaction.txnType == '1100'){
    			if(transaction.wfStatus=='ADJUST_CLIENT_END'&&transaction.txnEnable=='1'){
    				if(transaction.printStatus==0){
    					transaction.finalStatus='In thư';
					}else{
						transaction.finalStatus='Hoàn tất';
					}
    				flag = true;
				}
     		}else if(transaction.txnType == '1500'){
    			if(transaction.wfStatus=='ADJUST_ADD_LET_APP'&&transaction.txnEnable=='1'){
    				if(transaction.printStatus==0){
    					transaction.finalStatus='In thư';
					}else{
						transaction.finalStatus='Hoàn tất';
					}
    				flag = true;
				}
     		}else if(transaction.txnType == '1700'){
    			if(transaction.wfStatus=='POL_LA_REVERSAL_END'&&transaction.txnEnable=='1'){
    				if(transaction.printStatus==0){
    					transaction.finalStatus='In thư';
					}else{
						transaction.finalStatus='Hoàn tất';
					}
    				flag = true;
				}
     		}else if(transaction.txnType == '1900'){
    			if(transaction.wfStatus=='REG_SIGNATURE_END'&&transaction.txnEnable=='1'){
    				if(transaction.printStatus==0){
    					transaction.finalStatus='In thư';
					}else{
						transaction.finalStatus='Hoàn tất';
					}
    				flag = true;
				}
     		}else if(transaction.txnType == '1800'){
    			if(transaction.wfStatus=='CFI_POL_CANCEL_END' && transaction.txnEnable=='1'){
    				if(transaction.printStatus==0){
    					transaction.finalStatus='In thư';
					}else{
						transaction.finalStatus='Hoàn tất';
					}
    				flag = true;
				}
     		}else if(transaction.txnType == '2000'){
    			if(transaction.wfStatus=='FFG_CONTRACT_REVERT_END' && transaction.txnEnable=='1'){
    				if(transaction.printStatus==0){
    					transaction.finalStatus='In thư';
					}else{
						transaction.finalStatus='Hoàn tất';
					}
    				flag = true;
				}
     		}else if(transaction.txnType == '2100'){
    			if(transaction.wfStatus=='FFG_BILLING_CHANGE_END' && transaction.txnEnable=='1'){
    				if(transaction.printStatus==0){
    					transaction.finalStatus='In thư';
					}else{
						transaction.finalStatus='Hoàn tất';
					}
    				flag = true;
				}
     		} else if(transaction.txnType == '2800'){
				if(transaction.wfStatus=='FFG_GO_ABROAD_END' && transaction.txnEnable=='1'){
					if(transaction.printStatus==0){
						transaction.finalStatus='In thư';
					} else {
						transaction.finalStatus='Hoàn tất';
					}
					flag = true;
				}
			}
    		return flag;
    	}
    	
    	function printReport(txnType){
    	   searchCtr.reportParam = {'fromDate': searchCtr.fromCreatedDate,
					 'toDate': searchCtr.toCreatedDate,
					 'officeCode': searchCtr.officeCode,
					 'policyNum' : searchCtr.policyNum,
					 'receiptNum' : searchCtr.receiptNum,
					 'transactionType': searchCtr.transactionType,
					 'txn_id': searchCtr.txnId,
					 'formatExport': searchCtr.reportParam.formatExport,
					 'status': searchCtr.printStatus};
    		$scope.loading = true;
    		var uri = '';
    		switch (txnType) {
			case TRANSACTION_TYPE[0].code:
				uri = 'report-transaction-proposal';
				/*if(searchCtr.printStatus === '1000' || searchCtr.printStatus === '3000'){
					searchCtr.reportParam.status = null;
				}*/
				
				break;
			case TRANSACTION_TYPE[1].code:
				uri = 'report-transaction-policy';	
				/*if(searchCtr.printStatus === '2000' || searchCtr.printStatus === '4000'){
					searchCtr.reportParam.status = null;
				}*/
				break;
			case TRANSACTION_TYPE[2].code:
				uri = 'report-transaction-nb';
				break;	
			case TRANSACTION_TYPE[3].code:
			case TRANSACTION_TYPE[4].code:
				uri = 'report-transaction-payment';
				break;
			case TRANSACTION_TYPE[5].code:
				uri = 'report-transaction-claim-registration';
				break;
			case TRANSACTION_TYPE[6].code:
				uri = 'report-transaction-claim-bstt';
				break;
			case TRANSACTION_TYPE[7].code:
				uri = 'report-transaction-request';
				break;
			case TRANSACTION_TYPE[8].code:
				uri = 'report-transaction-po-address';
				break;
			case TRANSACTION_TYPE[9].code:
				uri = 'report-transaction-ben';
				break;
			case TRANSACTION_TYPE[10].code:
				uri = 'report-transaction-billing';
				break;
			case TRANSACTION_TYPE[11].code:
				uri = 'report-transaction-lapo';
				break;
			case TRANSACTION_TYPE[12].code:
				uri = 'report-transaction-personal-relation';
				break;
			case TRANSACTION_TYPE[13].code:
				uri = 'report-transaction-save-cancel-contract';
				break;
			case TRANSACTION_TYPE[15].code:
				uri = 'report-transaction-account-online';
				break;
			case TRANSACTION_TYPE[16].code:
				uri = 'report-transaction-d61d70';
				break;
			case TRANSACTION_TYPE[17].code:
				uri = 'report-transaction-cfi';
				break;
			case TRANSACTION_TYPE[18].code:
				uri = 'report-transaction-reg-signature-sample';
				break;
			case TRANSACTION_TYPE[19].code:
				uri = 'report-transaction-reinstallment';
				break;
			case TRANSACTION_TYPE[20].code:
				uri = 'report-transaction-billing-change';
				break;
			default:
				uri = 'report-transaction-history';
				break;
		}
    		if(uri != '') {
				ReportService.download({uri:uri}, searchCtr.reportParam,function(){
					$scope.loading = false;
				},
				function(){
					$scope.loading = false;
				});
			}
    	}
    	
    	searchCtr.tableParams = new NgTableParams({
    			page: 1,
    			count: 20,
    			sorting: {createdDate: 'desc'}
    		},
    		{
    			total: 0,
    			counts: [20, 40, 80],
    			defaultSort: 'desc',
    			getData: function(params) {
        		var param = {};
        		param['page'] = params.page();
        		param['size'] = params.count();
        		param['sort'] = params.sorting();
        		param['uri'] = 'spec';
        		if (searchCtr.fromCreatedDate) {
        			searchCtr.reportParam.fromDate = searchCtr.fromCreatedDate;
        			param['fromCreatedDate'] = $filter('date')(searchCtr.fromCreatedDate, FORMAT_DATE);
        		}        		
        		if (searchCtr.toCreatedDate) {
        			searchCtr.reportParam.toDate = searchCtr.toCreatedDate;
        			param['toCreatedDate'] = $filter('date')(searchCtr.toCreatedDate, FORMAT_DATE);
        		}
        		if (searchCtr.officeCode) {
        			searchCtr.reportParam.officeCode = searchCtr.officeCode;
        			param['officeCode'] = searchCtr.officeCode;
        		}
        		if (searchCtr.txnId) {
        			searchCtr.reportParam.txn_id = searchCtr.txnId;
        			param['txnId'] = searchCtr.txnId;
        		}
        		if (searchCtr.proposalPolicyNum) {
        			searchCtr.reportParam.policyNum = searchCtr.proposalPolicyNum;
        			param['proposalPolicyNum'] = searchCtr.proposalPolicyNum;
        		}
        		if (searchCtr.transactionType) {
        			searchCtr.reportParam.transactionType = searchCtr.transactionType;
        			param['txnType'] = searchCtr.transactionType;
        			if(searchCtr.transactionType === '100' || searchCtr.transactionType === '200'){
        				if (searchCtr.printStatus && searchCtr.printStatus !== 1000 
        						&& searchCtr.printStatus !== 2000
        						&& searchCtr.printStatus !== 3000
        						&& searchCtr.printStatus !== 4000) {
        					searchCtr.reportParam.status = searchCtr.printStatus;
        					param['printStatus'] = parseInt(searchCtr.printStatus);
        				}
        			}
        		}
        		if (searchCtr.receiptNum) {
        			searchCtr.reportParam.receiptNum = searchCtr.receiptNum;
        			param['receiptNum'] = searchCtr.receiptNum;
        		}
        		return TransactionService.query(param).$promise.then(function(result) {
        			params.total(result.totalElements);
    				return result.content;
    			});            	
            }
    	});
    }
})();
